import { connect } from "react-redux";
import { setMapTrailsVisible } from '../../data/preferences/actions';
import geofences from 'APP_ROOT/data/geofences';
import { loadActiveGeofences }  from 'APP_ROOT/data/geofences/actions';
import { DispatchHelpers as AssetMonitoringDispatchHelpers } from "../../data/assetMonitoring";
import { ACTIONS as layoutTemplateModularFullscreenDispatchActions } from 'APP_ROOT/data/layoutTemplateModularFullscreen/duck';
import MapboxMapDashboard from './mapboxMapDashboard';
import Permissions from "../../data/permissions";

const mapStateToProps = (state, ownProps) => {
    return {
        mapTrailsVisible: state.data.preferences.mapTrailsVisible,
        activeGeofenceIds: geofences.Selectors.activeGeofenceIds(state),
        geofenceName: (geofenceId) => geofences.Selectors.geofenceName(state, geofenceId),
        geofenceGeojson: (geofenceId) => geofences.Selectors.geofenceGeojson(state, geofenceId),
        geofenceType: (geofenceId) => geofences.Selectors.geofenceType(state, geofenceId, true),
        geofenceColor: (geofenceId) => geofences.Selectors.geofenceColor(state, geofenceId),
        isGeofenceVisible: (geofenceId) => geofences.Selectors.isGeofenceVisible(state, geofenceId),
        editingGeometry: () => geofences.Selectors.editingGeometry(state),
        canAccessAssets: Permissions.selectors.can(state, 'assets', 'read') && ownProps.features?.has_beacons,
        assets: state.data.assetMonitoring.assets,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setMapTrailsVisible: (visible) => {
            dispatch(setMapTrailsVisible(visible));
        },
        loadActiveGeofences: (stage) => {
            return dispatch(loadActiveGeofences(stage));
        },
        loadAllAssets: (stage) => {
            return dispatch(AssetMonitoringDispatchHelpers.loadAssets());
        },
        loadAllBeacons: (stage) => {
            return dispatch(AssetMonitoringDispatchHelpers.loadBeacons());
        },
        setLayoutFullscreen: (fullscreenModeIsActive) => {
            dispatch(layoutTemplateModularFullscreenDispatchActions.setFullscreenMode(fullscreenModeIsActive));
        },
        canSendDriverMessage: (ravenUuid) => dispatch(Permissions.thunks.can("ravens.driver_message", "send", { resourceId: ravenUuid })),
    }

};

export default connect(mapStateToProps, mapDispatchToProps)(MapboxMapDashboard);
